<div class="dialog">
    <div class="dialog-header">
        <h2>{{ data.title || ('shared.dialog.alert.api.heading' | translate) }}</h2>
    </div>
    <div class="dialog-body">
        <p>
            {{ 'shared.dialog.alert.api.text' | translate }}
            <br>
            "<strong [innerHTML]="data.message | capitalize | newlines"></strong>"
            <br>
            {{ 'shared.dialog.alert.api.retry' | translate }}
        </p>

        <div class="buttons">
            <a class="button button-primary" (click)="onClose()">{{ 'shared.button.close' | translate }}</a>
        </div>
    </div>
</div>

